import React from 'react';
import Section from '../../components/ui/Section';
import SafeIcon from '../../common/SafeIcon';

const Testimonials = () => {
  const reviews = [
    {
      name: "Sarah M.",
      role: "CEO & Gründerin",
      text: "Ich dachte immer, Erfolg muss hart sein. Jennifer hat mir gezeigt, wie ich aus meiner weiblichen Energie heraus führe. Mein Umsatz hat sich verdoppelt, meine Arbeitszeit halbiert. Purer Luxus für die Seele."
    },
    {
      name: "Elena R.",
      role: "Spiritueller Coach",
      text: "Der Love Code war mein Durchbruch. Nach Jahren der emotionalen Abhängigkeit fühle ich mich endlich souverän und frei. Die Dualseelen-Thematik hat plötzlich ihren Schrecken verloren."
    }
  ];

  return (
    <Section className="bg-darker relative">
      {/* Decorative Gold Element */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl"></div>

      <div className="text-center mb-16 relative z-10">
        <h2 className="text-4xl font-serif mb-4">Stimmen der <span className="italic text-wine-light">Queens</span></h2>
        <p className="text-cream/50 uppercase tracking-widest text-sm">Echte Transformation. Purer Social Proof.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto relative z-10">
        {reviews.map((review, idx) => (
          <div key={idx} className="glass-panel p-10 relative">
            <SafeIcon name="Star" className="text-gold text-2xl absolute top-10 right-10 opacity-50" />
            <p className="font-serif italic text-xl text-cream/90 leading-relaxed mb-8">"{review.text}"</p>
            <div>
              <p className="font-bold text-cream tracking-wider">{review.name}</p>
              <p className="text-sm text-gold uppercase tracking-widest mt-1">{review.role}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Testimonials;